import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "../assets/CSS/profile.css";
import "../assets/CSS/post.css";
import Post from "../components/Post";
import { useParams } from "react-router-dom";
import profilePicPlaceholder from "../assets/Images/ProfilePic-placeholder.jpg";
import bannerPlaceholder from "../assets/Images/Banner-placeholder.png";


function Profile() {
  // Fetch profileId from URL to fetch the correct data for the profile
  const { profileId } = useParams();
  // Conditions for posts, profile, bio and editingstate for bio
  const [posts, setPosts] = useState([]);
  const [profile, setProfile] = useState(null);
  const [bioInput, setBioInput] = useState("");
  const [isEditingBio, setIsEditingBio] = useState(false);

  // Fetch loggedin user form localStorage
  const user = JSON.parse(localStorage.getItem("loggedInUser"));
  const userId = user?.id;

  // References for the fileupload fields
  const bannerInputRef = useRef(null);
  const avatarInputRef = useRef(null);

  // Contdition for the follow-button and total followers
  const [isFollowing, setIsFollowing] = useState(false);
  const [hovering, setHovering] = useState(false);
  const [followerCount, setFollowerCount] = useState(0);

  // Condition to change the users name
  const [editNameMode, setEditNameMode] = useState(false);
  const [firstNameInput, setFirstNameInput] = useState("");
  const [lastNameInput, setLastNameInput] = useState("");

  // Fetches profile data, followerstatus and the profiles posts whenever profileId or userId changes
  useEffect(() => {
    if (!profileId) return;

    axios.get(`${process.env.REACT_APP_API_URL}/api/profiles/${profileId}`)
      .then((res) => {
        setProfile(res.data);
        fetchFollowerCount();
      })
      .catch((err) => console.error("Error while fetching profile:", err));

    if (parseInt(profileId) !== userId) {
      axios.get(`${process.env.REACT_APP_API_URL}/api/follow/isFollowing?followerId=${userId}&followingId=${profileId}`)
        .then(res => setIsFollowing(res.data))
        .catch(err => console.error("Error fetching follow-status:", err));
    }

    axios.get(`${process.env.REACT_APP_API_URL}/posts/details/user/${profileId}`)
      .then((res) => setPosts(res.data))
      .catch((err) => console.error("Error while fetching posts:", err));
  }, [profileId, userId]);

  // Function to handle Banner
  const handleBannerClick = () => bannerInputRef.current?.click();

const handleBannerChange = async (e) => {
  const file = e.target.files[0];
  const MAX_FILE_SIZE_MB = 5; //Legger inn maks størrelse med error handling direkte i frontend slik at Windows også får det

  if (file && file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
    alert(`File is too big! Max size is ${MAX_FILE_SIZE_MB}MB`);
    return;
  }

  if (!file) return;

  const formData = new FormData();
  formData.append("file", file);

  try {
    await axios.post(
      `${process.env.REACT_APP_API_URL}/images/uploadBannerImage?profileId=${profileId}`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/profiles/${profileId}`);
    setProfile(res.data);
  } catch (err) {
    console.error("Feil ved opplasting av banner:", err);
    if (err.response && err.response.status === 413) {
      alert("Picture is too big, must be under 5MB!");
    } else {
      alert("Something went wrong during the upload. Please try again later.");
    }
  }
};



  // Function to handle Avatar
  const handleAvatarClick = () => avatarInputRef.current?.click();

 const handleAvatarChange = async (e) => {
  const file = e.target.files[0];

  const MAX_FILE_SIZE_MB = 5; //Legger inn maks størrelse med error handling direkte i frontend slik at Windows også får det

  if (file && file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
    alert(`File is too big! Max size is ${MAX_FILE_SIZE_MB}MB`);
    return;
  }

  if (!file) return;
  const formData = new FormData();
  formData.append("file", file);
  try {
    await axios.post(`${process.env.REACT_APP_API_URL}/images/uploadProfileImage?profileId=${profileId}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/profiles/${profileId}`);
    setProfile(res.data);
  } catch (err) {
    console.error("Feil ved opplasting av profilbilde:", err);
    if (err.response && err.response.status === 413) {
      alert("Picture is too big, must be under 5MB!");
    } else {
      alert("Something went wrong during the upload. Please try again later.");
    }
  }
};


  // Function to handle Follow
  const handleFollow = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/follow/${profileId}?followerId=${userId}`);
      setIsFollowing(true);
      fetchFollowerCount();
    } catch (error) {
      console.error("Error trying to follow:", error);
    }
  };

  // Function to handle Unfollow
  const handleUnfollow = async () => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/api/follow/${profileId}?followerId=${userId}`);
      setIsFollowing(false);
      fetchFollowerCount();
    } catch (error) {
      console.error("Error trying to unfollow:", error);
    }
  };

  // Function to handle total followercount to the relevant profile
  const fetchFollowerCount = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/follow/count/${profileId}`);
      setFollowerCount(response.data);
    } catch (err) {
      console.error("Kunne ikke hente antall følgere:", err);
    }
  };

  // Function to change the users name
  const handleSaveName = async () => {
    // Begrens navnene til maks 30 tegn, 
  if (firstNameInput.length > 30 || lastNameInput.length > 30) {
    alert("Too many letters");
    return;
  }
    try {
      const updatedProfile = { 
        firstName: firstNameInput, 
        lastName: lastNameInput 
      };
      await axios.put(`${process.env.REACT_APP_API_URL}/api/profiles/${profileId}/name`, updatedProfile, {
        headers: { "Content-Type": "application/json" }
      });
      // Updating the profile after saving new vaule:
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/profiles/${profileId}`);
      setProfile(res.data);

      // Updating localStorage so the navbar shows the correct updated name
      localStorage.setItem("loggedInUser", JSON.stringify({
        ...user,
        firstName: firstNameInput,
        lastName: lastNameInput
      }));

      setEditNameMode(false);
    } catch (err) {
      console.error("Error updating name:", err);
    }
  };

  // Function to fetch posts for the profile and able to delete them
  const fetchPosts = () => { 
  axios.get(`${process.env.REACT_APP_API_URL}/posts/details/user/${profileId}`)
    .then((res) => setPosts(res.data))
    .catch((err) => console.error("Error while fetching posts:", err));
  };

  // This is where the profile renders with images and information with editable sections for the logged-in user
  return (
    <div id="profile">
      {/* Confirming if the profile is loading */}
      {profile ? (
        <>
          {/* Profilbanner section, only editable by the owner */}
          <div
          className={`profile-banner ${String(profileId) === String(userId) ? "editable" : ""}`} 
          onClick={String(profileId) === String(userId) ? handleBannerClick : undefined}
          >
            <img
              src={profile.bannerUrl ? `${process.env.REACT_APP_API_URL}${profile.bannerUrl}` : bannerPlaceholder}
              alt="Profile Banner"
              className="profile-banner-img"
            />
            {/* Input to change the banner */}
            <input
              type="file"
              accept="image/*"
              ref={bannerInputRef}
              style={{ display: "none" }}
              onChange={handleBannerChange}
            />
          </div>

          {/* Profileinformation */}
          <div className="profile-info">
            <div className="profile-left">
              {/* Profileimage, only editable by the owner */}
              <div
              className={`profile-avatar ${String(profileId) === String(userId) ? "editable" : ""}`}
              onClick={String(profileId) === String(userId) ? handleAvatarClick : undefined}
              >
                <img
                  src={profile.profilePicUrl ? `${process.env.REACT_APP_API_URL}${profile.profilePicUrl}` : profilePicPlaceholder}
                  alt="Profile Avatar"
                  className="profile-avatar-img"
                />
                {/* Input to change the Profileimage */}
                <input
                  type="file"
                  accept="image/*"
                  ref={avatarInputRef}
                  style={{ display: "none" }}
                  onChange={handleAvatarChange}
                />
              </div>

              {/* Display username and followercount */}
              <div>
                <h1>{profile.firstName} {profile.lastName}</h1>
                <p className="friends">Followers: {followerCount}</p>
              </div>

              {/* Update the user's firstname and lastname */}
              <div>
                {editNameMode ? (
                  <>
                    <input
                      value={firstNameInput}
                      onChange={(e) => setFirstNameInput(e.target.value)}
                      placeholder="First name"
                    />
                    <input
                      value={lastNameInput}
                      onChange={(e) => setLastNameInput(e.target.value)}
                      placeholder="Last name"
                    />
                    <button onClick={handleSaveName}>Save</button>
                    <button onClick={() => setEditNameMode(false)}>Cancel</button>
                  </>
                ) : (
                  <>
                    {String(profileId) === String(userId) && (
                      <button onClick={() => {
                        setFirstNameInput(profile.firstName || "");
                        setLastNameInput(profile.lastName || "");
                        setEditNameMode(true);
                      }}>
                        Edit name
                      </button>
                    )}
                  </>
                )}
              </div>

              {/* Follow/Unfollow-button, only shown when viewing another profile */}
              <div>
                {String(profileId) !== String(userId) && (
                  <button
                    onClick={isFollowing ? handleUnfollow : handleFollow}
                    onMouseEnter={() => setHovering(true)}
                    onMouseLeave={() => setHovering(false)}
                  >
                    {isFollowing ? (hovering ? "Unfollow" : "Followed") : "Follow"}
                  </button>
                )}
              </div>
            </div>
            
            {/* Bio section */}
            <div className="profile-right">
              {isEditingBio ? (
                String(profileId) === String(userId) && (
                  <>
                    {/* Input to change the bio */}
                    <input
                      value={bioInput}
                      onChange={(e) => setBioInput(e.target.value)}
                    />
                    {/* Button state when editing bio */}
                  <button
  onClick={() => {
    axios.put(`${process.env.REACT_APP_API_URL}/api/profiles/${profileId}/bio`, bioInput, {
      headers: { "Content-Type": "text/plain" }
    })
    .then(() => {
      setIsEditingBio(false);
      axios.get(`${process.env.REACT_APP_API_URL}/api/profiles/${profileId}`)
        .then(res => setProfile(res.data));
    })
    .catch((err) => {
      if (err.response && err.response.status === 400) {
        alert(err.response.data); // viser f.eks. "Bio too long"
      } else {
        alert("Something went wrong when saving bio.");
      }
    });
  }}
>
  Save
</button>

                </>
                )
              ) : (
                <>
                  {/* Button to change the bio, only shown to the owner */}
                  <p>Bio: {profile.bio}</p>
                  {String(profileId) === String(userId) && (
                    <button
                      className="edit-bio-btn"
                      onClick={() => {
                        setIsEditingBio(true);
                        setBioInput(profile.bio);
                      }}
                    >
                    Edit bio
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
          
          {/* Posts section */}
          <div className="feed-container">
            {posts.length > 0 ? (
              <Post posts={posts} fetchPosts={fetchPosts}/>
            ) : (
              <p className="no-posts-message">
                This user doesn't have any posts yet.
              </p>
            )}
          </div>
        </>
      ) : (
        <p>Loading profile...</p>
      )}
    </div>
  );
}

export default Profile;